module.exports = __webpack_public_path__ + "static/media/HELI-CPD30-3.a3bd7b4d.jpg";